import { RESET_FORM } from '../actionTypes';
import { configurationDocumentsActions } from '../reducer';

export default () => configurationDocumentsActions[RESET_FORM]();
